import { render, staticRenderFns, recyclableRender, components } from "./noveltyManger.vue?vue&type=template&id=8b1b171e&"
var renderjs
import script from "./noveltyManger.vue?vue&type=script&lang=js&"
export * from "./noveltyManger.vue?vue&type=script&lang=js&"
import style0 from "./noveltyManger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/noveltyManger/noveltyManger.vue"
export default component.exports